import gql from 'graphql-tag'

// Create new contact
export const createContact = gql`
	mutation($nameFirst: String!, $nameLast: String!, $birthDate: Json!, $birthPlace: Json!, $birthTime: Json!, $birthSigns: Json!) {
		createContacts(
			nameFirst: $nameFirst
			nameLast: $nameLast
			birthDate: $birthDate
			birthPlace: $birthPlace
			birthTime: $birthTime
			birthSigns: $birthSigns
			) {
				id
		}
	}
`

// Assign contact to user
export const assignContactToUser = gql`
	mutation($userId: ID!, $contactId: ID!) {
		addToContactsForEachUser(userUserId: $userId, contactsContactsId: $contactId) {
			contactsContacts {
				id
			}
		}
	}
`

export const triggerSubscription = gql`
	mutation($contactId: ID!, $updateTrigger: DateTime!) {
		updateContacts(
			id: $contactId
			updateTrigger: $updateTrigger
		) {
			id
		}
	}
`

export const updateContact = gql`
	mutation ($id: ID!, $nameFirst: String!, $nameLast: String!, $birthDate: Json!, $birthPlace: Json!, $birthTime: Json!, $birthSigns: Json!) {
		updateContacts(
			id: $id
			nameFirst: $nameFirst
			nameLast: $nameLast
			birthDate: $birthDate
			birthPlace: $birthPlace
			birthTime: $birthTime
			birthSigns: $birthSigns
		) {
				id
			}
		}
`

export const deleteContact = gql`
	mutation ($id: ID!) {
		deleteContacts(id: $id) {
			id
			nameFirst
			nameLast
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/contacts.js